import type { IRootDispatch, RootState } from './models';
import { ssFetchJSON } from '../modules/ssFetch';
import { SEO_SERVICE_READ } from '../config';

type FAQ = {
  question: string;
  answer: string;
};

type RelatedLink = {
  title: string;
  slug: string;
};

export type SEOData = {
  id: string;
  description: string;
  blurb: string;
  faq?: FAQ[];
  relatedServices?: RelatedLink[];
  meta_description?: string;
};

type State = {
  pages: {
    [key: string]: SEOData;
  };
  /**
   * unFound tracks the seo data which fails to load, basically
   * if we don't find seo data we don't want to keep executing fetch
   * requests for it, so this is basically a "we already checked for
   * this and didn't find it" list.
   * */
  unFound: {
    [key: string]: true;
  }
};

const model = {
  name: 'seoData',

  state: {
    pages: {},
    unFound: {},
  } as State,

  reducers: {
    onFound(state: State, {
      slug,
      seoData,
    }: {
      slug: string,
      seoData: SEOData,
    }) {
      return {
        ...state,
        pages: {
          ...state.pages,
          [slug]: seoData,
        },
      };
    },

    onUnFound(state: State, slug: string) {
      return {
        ...state,
        unFound: {
          ...state.unFound,
          [slug]: true,
        },
      };
    },
  },

  effects: (dispatch: IRootDispatch) => ({
    loadSEOData: async (slug: string, rootState: RootState) => {
      // This data really doesn't change very often so we never need
      // to re-fetch this data.
      if (!(rootState.seoData.pages[slug] || rootState.seoData.unFound[slug])) {
        try {
          const seoData = await ssFetchJSON(`${SEO_SERVICE_READ}/${slug}`);
          if (seoData.length > 0) {
            dispatch.seoData.onFound({
              slug,
              seoData: seoData[0],
            });
          } else {
            dispatch.seoData.onUnFound(slug);
          }
        } catch (e) {
          dispatch.seoData.onUnFound(slug);
        }
      }
    },
  }),
};

export default model;
